import React, { useEffect, useState } from "react";
import { UsersInnerOptions } from "../UsersInnerOptions";
import { useQuery } from "react-query";
import { getAdmins } from "hooks/api/Users/getAdmins";
import { useErrorHandler } from "Exceptions/ErrorHandler";
import { SettingLayout } from "layouts/SettingLayout";
import { useColumns } from "./columns";
import { DataTable } from "components/ui/DataTable";
import { Admin } from "contracts/Admins";

const ListAdmin = () => {
  const { options } = UsersInnerOptions();
  const [localData, setLocalData] = useState<Admin[]>([]);
  const { errorHandler } = useErrorHandler();
  const { columns } = useColumns();
  const { data, isLoading } = useQuery({
    queryKey: "admins",
    queryFn: getAdmins,
    onError: errorHandler,
  });

  useEffect(() => {
    if(data) {
        setLocalData(data);
    }
    return () => {
        setLocalData([]);
    };
}, [data]);
  return (
    <SettingLayout options={options}>
      <DataTable
        isLoading={isLoading}
        filterBy={'Nome'}
        data={localData ?? []}
        columns={columns}
        showControlColumns={false}
      />
    </SettingLayout>
  );
};

export default ListAdmin;
